var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchiconsmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 14.25C9.81281 14.2498 11.2493 13.7793 12.4145 12.9137L16.0778 16.3939L17.2562 15.2745L13.5928 11.7943C14.5045 10.6873 15 9.32226 15.0003 7.91671C15.0003 4.42467 12.0095 1.58337 8.33366 1.58337C4.65783 1.58337 1.66699 4.42467 1.66699 7.91671C1.66699 11.4087 4.65783 14.25 8.33366 14.25ZM8.33366 3.16671C11.0912 3.16671 13.3337 5.29708 13.3337 7.91671C13.3337 10.5363 11.0912 12.6667 8.33366 12.6667C5.57616 12.6667 3.33366 10.5363 3.33366 7.91671C3.33366 5.29708 5.57616 3.16671 8.33366 3.16671Z",
    fill: "white",
    fillOpacity: 0.22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchiconsmall);
export default __webpack_public_path__ + "static/media/searchiconsmall.2bce93688430c20fa696830cf1176180.svg";
export { ForwardRef as ReactComponent };